import React from 'react';
import SMConst from 'lib/SMConst';
import SMMapHelper from 'components/helpers/SMMapHelper';
import SMFormFieldBaseView from 'components/dashboard/form/SMFormFieldBaseView';

class SMOSpaceMapView extends SMFormFieldBaseView {
  
  constructor(props) {
    super(props);
    this.state = {
      latitude: this.props.space.latitude,
      longitude: this.props.space.longitude,
    };
    this.googleMap = null;
    this.marker = null;
  }
  
  componentDidMount() {
    // タブが表示されている状態（カレント）でないと、GoogleMapは表示されない
    if (this.props.display == SMConst.Display.Visible) {
      this.showMap();
    }
  }
  
  componentWillReceiveProps(nextProps) {
    this.setState(function(previousState, currentProps) {
      previousState.latitude = currentProps.space.latitude;
      previousState.longitude = currentProps.space.longitude;
      return {
        latitude: previousState.latitude,
        longitude: previousState.longitude,
      };
    });        
  }
  
  componentDidUpdate(prevProps, prevState) {
    if ((prevProps.display == SMConst.Display.Hidden && this.props.display == SMConst.Display.Visible) ||
        prevState.latitude != this.state.latitude ||
        prevState.longitude != this.state.longitude) {
      this.showMap();
    }
  }
  
  showMap() {
    if (!this.googleMap) {
      const latField = $(this.refs.latitude);
      const lngField = $(this.refs.longitude);
      const position = new google.maps.LatLng(latField.val(), lngField.val());
      this.googleMap = SMMapHelper.googleMap(this.refs.mapCanvas, position, 15);
      this.marker = new google.maps.Marker({
        position: position,
        draggable:true,
        animation: google.maps.Animation.DROP,
        icon:this.googleMap.markerImage,
        map: this.googleMap.map
      });
      google.maps.event.addListener(this.marker, 'dragend', (event)=>{
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        const newPosition = new google.maps.LatLng(lat, lng);
        this.googleMap.map.panTo(newPosition);
        this.setState({
          latitude: lat,
          longitude: lng,
        });
        this.props.delegate.googleMapDragEnd(event);
      });
    } else {
      const newPosition = new google.maps.LatLng(
        (this.state.latitude || 35.6922055),
        (this.state.longitude || 139.6874118)
      );
      this.googleMap.map.panTo(newPosition);
      this.marker.setPosition(newPosition);
    }
  }
  
  render() {
    return (
      <div className="form-box">
        <input type='hidden' name={this.props.name} value='0' />
        <input type="checkbox" name={this.props.name} value="1" id="form-checkbox01__01" defaultChecked={this.props.space.has_map_view} onChange={this.props.delegate.checkBoxDidChangeValue} />
        <label htmlFor="form-checkbox01__01" className="form-checkbox">{I18n.t("dashboard.label_000130")}</label><br />
        <div ref="mapCanvas" className="w720 h300"></div>
        <input type="hidden" value={this.state.latitude} name="latitude" ref="latitude" />
        <input type="hidden" value={this.state.longitude} name="longitude" ref="longitude" />
      </div>
    );
  }
}

SMOSpaceMapView.defaultProps = {
  display: SMConst.Display.Visible,
};

export default SMOSpaceMapView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/spaces/SMOSpaceMapView.jsx